import { render } from "./VModal.vue?vue&type=template&id=71bc0e78"
import script from "./VModal.vue?vue&type=script&lang=js"
export * from "./VModal.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__